import { Switch } from 'react-router-dom';

import { routes } from './config.routes';
import { Route } from './Route';

export function Router() {
  return (
    <Switch>
      {routes.map((route) => {
        return (
          <Route
            key={`${route.path}-router`}
            isPrivate={route.isPrivate}
            isPremium={route?.isPremium}
            exact={route.exact}
            path={route.path}
            pageName={route.pageName}
            layout={route.layout}
          >
            {route.children}
          </Route>
        );
      })}
    </Switch>
  );
}
